import React from 'react';
import { Link } from 'react-router-dom';
import SectionHeader from '../components/SectionHeader';

export default function Cart({ cartItems, updateQty, removeItem }) {
  const total = (cartItems || []).reduce((sum, item) => {
    const price = item.count >= 100 ? item.product.price100
      : item.count >= 50 ? item.product.price50
      : item.product.price;
    return sum + price * item.count;
  }, 0);

  if (!cartItems || cartItems.length === 0) {
    return (
      <div className="page-wrapper">
        <div className="container">
          <SectionHeader title="Shopping Cart" />
          <div className="card">
            <div className="card-body" style={{ textAlign: 'center', padding: '3rem' }}>
              <p style={{ marginBottom: '1.5rem', color: 'var(--text-muted)', fontSize: '1.1rem' }}>Your cart is empty.</p>
              <Link to="/order-products" className="btn btn-primary">Browse Products</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="container">
        <SectionHeader title="Shopping Cart" />

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '1.5rem', alignItems: 'start' }}>
          {/* Cart items */}
          <div className="card">
            <div className="card-body" style={{ padding: 0 }}>
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Subtotal</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item, idx) => {
                    const price = item.count >= 100 ? item.product.price100
                      : item.count >= 50 ? item.product.price50
                      : item.product.price;
                    return (
                      <tr key={idx}>
                        <td>
                          <strong>{item.product.title}</strong>
                          <br />
                          <small style={{ color: 'var(--text-muted)' }}>by {item.product.author}</small>
                        </td>
                        <td>${price.toFixed(2)}</td>
                        <td>
                          <div className="qty-control">
                            <button onClick={() => updateQty(idx, item.count - 1)}>−</button>
                            <span style={{ minWidth: 30, textAlign: 'center' }}>{item.count}</span>
                            <button onClick={() => updateQty(idx, item.count + 1)}>+</button>
                          </div>
                        </td>
                        <td><strong>${(price * item.count).toFixed(2)}</strong></td>
                        <td>
                          <button
                            onClick={() => removeItem(idx)}
                            className="btn btn-sm"
                            style={{ background: 'none', color: 'var(--danger)', border: '1px solid var(--danger)', padding: '0.2rem 0.5rem', borderRadius: 4, cursor: 'pointer' }}
                          >
                            ✕
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* Order summary */}
          <div>
            <div className="order-summary card">
              <div className="card-header"><h4>Order Summary</h4></div>
              <div className="card-body">
                {cartItems.map((item, idx) => {
                  const price = item.count >= 100 ? item.product.price100
                    : item.count >= 50 ? item.product.price50
                    : item.product.price;
                  return (
                    <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                      <span>{item.product.title} × {item.count}</span>
                      <span>${(price * item.count).toFixed(2)}</span>
                    </div>
                  );
                })}
                <hr style={{ margin: '1rem 0', borderColor: '#ddd' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: '1.05rem' }}>
                  <span>Total</span>
                  <span>${total.toFixed(2)}</span>
                </div>
                <br />
                <Link to="/checkout" className="btn btn-primary btn-block">
                  Proceed to Checkout
                </Link>
                <br />
                <Link to="/order-products" className="btn btn-outline-primary btn-block" style={{ marginTop: '0.5rem' }}>
                  Continue Shopping
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
